export default __webpack_public_path__ + "static/media/map-1.b1a2c1ce.png";